<app-attachment-selector
  class="w-100"
  [headerProducts]="products().selectedProducts"
  [products]="productsForAttachmentSelector()"
  [showCosts]="showCosts"
  (attachmentsSelect$)="attachmentsSelect$.emit($event)"
></app-attachment-selector>
